<template>
    <div class="page-cabinet__pagination" v-if="!!paginationRanges.length">
        <div>Показать объекты:</div>
        <div
            v-for="(range, index) in paginationRanges"
            :key="range"
            class="page-cabinet__pagination-item"
            :class="{'_active': currentPage === index + 1}"
            @click="() => $emit('change-page', index + 1)"
        >
            {{ range }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'page-cabinet-pagination',
    props: {
        currentPage: {
            type: Number,
            default: 1,
        },
        totalItems: {
            type: Number,
            default: 0,
        },
        perPage: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        paginationRanges() {
            if (isNaN(this.totalItems) || isNaN(this.perPage)) {
                return [];
            }
            const totalPages = Math.ceil(this.totalItems / this.perPage);
            const paginationRanges = [];
            for (let i = 0; i < totalPages; i++) {
                const start = i * this.perPage + 1;
                const end = Math.min(start + this.perPage - 1, this.totalItems);
                paginationRanges.push(start !== end ? `${start}-${end}` : start);
            }
            return paginationRanges;
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet__pagination {
    .typography-body();

    display: flex;
    flex-direction: row;
    gap: 8px;

    &-item {
        flex-shrink: 0;
        text-decoration: underline;
        color: @color-gray-main;
        cursor: pointer;
        &._active {
            color: @color-primary;
        }
    }
}

</style>
